<div class="select-calculation" *ngIf="selectingCalculation">
    <div class="header">
        <div class="text">Selecteer calculatie</div>
    </div>

    <div class="options">
        <div class="search-bar" [class.selected]="searchBarSelected">
            <input #search (keyup)="searchInputChange(search.value)" (focus)="focusSearchBar()" (blur)="blurSearchBar()"
                placeholder="Zoeken (projectnummer en -omschrijving)" />
            <div class="fas fa-search"></div>
        </div>

        <div class="filters">
            <span class="title">Filters</span>
            <div class="filter-option button-new" [class.inactive]="projFilterActive$ | async | not"
                (click)="toggleFilterValue('isActive')">
                <div class="description">Lopend</div>
            </div>
            <div class="filter-option button-new" [class.inactive]="projFilterClosed$ | async | not"
                (click)="toggleFilterValue('isClosed')">
                <div class="description">Afgesloten</div>
            </div>
        </div>
    </div>

    <div class="content">
        <div class="project-list">

            <div class="scrollable">

                <!-- Loading spinner -->
                <ng-template #spinner>
                    <div class="spinner-container">
                        <div class="spinner">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </ng-template>

                <ng-container *ngIf="filteredProjects$ | async as filteredProjects; else spinner">

                    <!-- Row for the project -->
                    <div *ngFor="let project of filteredProjects; let i = index" class="project"
                        [class.closed]="project.active | not">
                        <div class="project-details">
                            <div class="id">{{ project.id }}</div>
                            <div class="item">
                                <div class="description">{{ project.description }}</div>
                            </div>
                            <div class="date">{{ project.created | date:'dd-MM-yyyy' }}</div>
                        </div>

                        <!-- Define a reusable template for a list of calculations -->
                        <ng-template #calcList let-calculations="calculations" let-project="project">
                            <ng-container *ngFor="let calc of calculations">

                                <!-- Render each calculation -->
                                <div class="calculation" [class.closed]="project.active | not"
                                    (click)="selectCalculation(project, calc)">

                                    <div class="item">
                                        <div class="color-code"
                                            [class.stabu]="['stabu', 'stabu-en'] | includes:calc.meta.templateName"
                                            [class.variations]="calc.meta.templateName | equals: 'mmw'">
                                        </div>
                                        <div class="template">
                                            <div class="template-name"
                                                [class.stabu]="['stabu', 'stabu-en'] | includes:calc.meta.templateName"
                                                [class.variations]="calc.meta.templateName | equals: 'mmw'">
                                                {{ calc.meta.templateName }}
                                            </div>
                                        </div>
                                        <div class="description">{{ calc.meta.description }}</div>
                                        <div class="version">v{{ calc.meta.currentVersion }}</div>
                                    </div>

                                    <div class="date">{{ calc.meta.versionDate | date:'dd-MM-yyyy' }}</div>
                                </div>

                                <!-- If there are linked calculations, render them one level deeper -->
                                <div class="linked-calculations" *ngIf="calc.children?.length | greaterThan: 0">
                                    <ng-container [ngTemplateOutlet]="calcList"
                                        [ngTemplateOutletContext]="{ calculations: calc.children, project: project }">
                                    </ng-container>
                                </div>

                            </ng-container>

                        </ng-template>


                        <!-- Rows for the calculations that belong to this project -->

                        <div class="calculations" *ngIf="project?.calculations?.length | greaterThan: 0">
                            <ng-container [ngTemplateOutlet]="calcList"
                                [ngTemplateOutletContext]="{ calculations: project.calculations, project: project }">
                            </ng-container>
                        </div>

                    </div>

                </ng-container>

            </div>
        </div>
    </div>
    <div class="footer">

    </div>
</div>

<div class="select-lines" *ngIf="selectingCalculation | not">
    <div class="header">
        <div class="text">Kopieer regels</div>

        <mat-form-field>
            <mat-label>Calculatieversie</mat-label>
            <select matNativeControl [(ngModel)]="selectedVersion" (change)="versionChange($event)">
                <ng-container *ngFor="let version of versions$ | async">
                    <option [value]="version.version" [selected]="version.version === selectedVersion">{{ version.label }}</option>
                </ng-container>
            </select>
        </mat-form-field>
    </div>
    <div class="content">
        <div class="container-header" (click)="clickSelectEverything($event)">
            <input class="regular-checkbox" type="checkbox" [checked]="allSelected">
            <div class="text">Alles</div>
        </div>
        <div class="lines-container">
            <div class="spinner-container" *ngIf="loadingCategories">
                <div class="spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div class="category-view" *ngFor="let category of categoryViews">
                <div class="category" (click)="category.open = !category.open" [class.open]="category.open">
                    <input type="checkbox" (click)="clickCategoryCheckbox($event, category)"
                        [checked]="category.selected" class="regular-checkbox" />
                    <div class="opener">
                        <i class="fas" [class.fa-caret-right]="category.open | not"
                            [class.fa-caret-down]="category.open"></i>
                    </div>
                    <div class="code">{{ category.code }}</div>
                    <div class="description">{{ category.description }}</div>
                </div>
                <ng-container *ngIf="category.open">
                    <div class="sub-category" (click)="clickSubCategoryCheckbox($event, category, subCategory)"
                        *ngFor="let subCategory of category.subCategories">
                        <input type="checkbox" (click)="clickSubCategoryCheckbox($event, category, subCategory)"
                            [checked]="subCategory.selected" class="regular-checkbox" />
                        <div class="code">{{ subCategory.code }}</div>
                        <div class="description">{{ subCategory.description }}</div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="footer">
        <section>
            <input class="regular-checkbox" type="checkbox" [(ngModel)]="importHourlyRates">
            <label>Uurlonen kopiëren</label>
        </section>
        <section *ngIf="hasTail">
            <input class="regular-checkbox" type="checkbox" [(ngModel)]="importTail">
            <label>Staart kopiëren</label>
        </section>
        <div style="flex: 1"></div>
        <div class="button-thin" [class.active]="hasSelection | or: importTail" (click)="importSelection()">Kopieer
        </div>
    </div>
</div>